module.exports = __webpack_public_path__ + "discount.png?498bfa13e8cd84732d83d328bce9af5a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discount.png
// module id = 865
// module chunks = 0